import type { PropsWithChildren } from 'react'
import { useOutletContext } from 'react-router-dom'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import LocationHolidays from 'modules/locations/components/Holidays'
import companyHolidays from 'modules/timeoff/store/collections/companyHolidays'

type Props = Record<string, unknown>

const HolidaysComponent = ({ children }: PropsWithChildren<Props>) => {
  const { locationId } = useOutletContext<{ locationId: string }>()

  const { loading } = useAsyncData(() => companyHolidays.fetch(), [])

  return (
    <ResponsivePage.Body variant="wide" loading={loading} error={null} showHeader={false}>
      {children}
      <LocationHolidays locationId={locationId} />
    </ResponsivePage.Body>
  )
}

export default HolidaysComponent
